import React from "react";
import {
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import damasLogo from "src/assets/images/logo.png";
import moment from "moment";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: 10,
    // backgroundColor: '#E4E4E4'
  },
  section: {
    marginLeft: 15,
    padding: 10,
    flexGrow: 1,
  },
  image: {
    width: 120,
    float: "left",
  },
  header: {
    flexDirection: "row",
    justifyContent: "flex-end",
    padding: 10,
  },
  dateText: {
    fontSize: 10,
  },
});
const ExportTripPdfComponent = ({ data }) => {
  const currentDate = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
  });

  console.log(data);
  return (
    <Page size="A4" style={styles.page}>
      <View style={styles.header}>
        <Text style={styles.dateText}>Report generated on {currentDate}</Text>
      </View>

      <View style={styles.section}>
        <Image style={styles.image} src={damasLogo} />
        <Text>
          Trip Report:
          {/* {filteredData && `Filtered by ${filteredData.join(", ")}`}  */}
          Total {data.length} entries
        </Text>
        <View style={{ flexDirection: "row", marginTop: 10 }}>
          <Text style={{ width: 120, fontSize: 11 }}>Trip ID</Text>
          <Text style={{ width: 120, fontSize: 11 }}>Trip Name</Text>
          <Text style={{ width: 120, fontSize: 11 }}>Country</Text>
          <Text style={{ width: 60, fontSize: 11 }}>Orders</Text>
          <Text style={{ width: 120, fontSize: 11 }}>Creation Time</Text>
          <Text style={{ width: 50, fontSize: 11 }}>Route</Text>
          <Text style={{ width: 50, fontSize: 11 }}>Driver</Text>
          <Text style={{ width: 50, fontSize: 11 }}>Status</Text>
          <Text style={{ width: 50, fontSize: 11 }}>Priority</Text>
        </View>
        {data.map((item, index) => (
          <View key={index} style={{ flexDirection: "row", marginTop: 3 }}>
            <Text style={{ width: 120, fontSize: 9 }}>{item.tripId}</Text>
            <Text style={{ width: 120, fontSize: 9 }}>
              {String(item.tripName).substring(0, 10)}...
            </Text>
            <Text style={{ width: 120, fontSize: 9 }}>{item.country}</Text>
            <Text style={{ width: 60, fontSize: 9 }}>{item.orderCount}</Text>
            <Text style={{ width: 120, fontSize: 9 }}>
              {moment(item.createdAt).format("DD-MM-YYYY h:mm A")}
            </Text>
            <Text style={{ width: 50, fontSize: 9 }}>
              {item.tripRoute.name}
            </Text>
            <Text style={{ width: 50, fontSize: 9 }}>
              {item.tripAssignedTo}
            </Text>
            <Text style={{ width: 50, fontSize: 9 }}>{item.tripStatus}</Text>
            <Text style={{ width: 50, fontSize: 9 }}>{item.priority}</Text>
          </View>
        ))}
      </View>
    </Page>
  );
};

export default ExportTripPdfComponent;
